import { debounce } from "ts-debounce";
import { Container } from "./container";
import { isDocumentVisible } from "./polling";

export type PointerTelemetry = {
	lastMove: Date
}

/**
 * Global user-activity signals shared by the whole app: pointer movement and tab visibility.
 *
 * Events:
 *  - `visibility`: the browser tab was shown or hidden; read `visible` for the new state. Pollers
 *    that schedule themselves (JobWatcher, ChatPoller) pause on hidden and resume on visible; fixed
 *    interval refreshes should use {@link Polling}, which does the same on its own.
 */
export class Telemetry extends EventTarget {

	readonly pointer: PointerTelemetry = {
		lastMove: null
	}

	/** True while the browser tab is visible — the only state in which polling runs. */
	get visible() { return isDocumentVisible() }

	_onMouseMove = debounce((_e: MouseEvent) => {
		this.pointer.lastMove = new Date();
	}, 1000);

	_onVisibilityChange = () => {
		this.dispatchEvent(new Event('visibility'));
	}

	constructor(readonly container: Container) {
		super();
		document.addEventListener('mousemove', this._onMouseMove);
		document.addEventListener('visibilitychange', this._onVisibilityChange);

		window.onerror = (message, source, lineno, colno, error) => {
			error = error || new Error(typeof message === 'string' ? message : 'Unknown error');
			this.processError(error);
			return false;
		}
	}

	processError(error: Error) {

	}

	dispose() {
		document.removeEventListener('mousemove', this._onMouseMove);
		document.removeEventListener('visibilitychange', this._onVisibilityChange);
	}

}
